export const SET_CUSTOMER_INFO = 'SET_CUSTOMER_INFO'
export const FAILED_SET_CUSTOMER_INFO = 'FAILED_SET_CUSTOMER_INFO'
export const SET_CUSTOMER_PACKAGE_INFO = 'SET_CUSTOMER_PACKAGE_INFO'
export const FAILED_SET_CUSTOMER_PACKAGE_INFO =
  'FAILED_SET_CUSTOMER_PACKAGE_INFO'
export const SET_AVAILABLE_PROGRAMS = 'SET_AVAILABLE_PROGRAMS'
export const SET_PACKAGE_DETAILS = 'SET_PACKAGE_DETAILS'
export const SET_BILLS_DATA = 'SET_BILLS_DATA'
export const SET_INSTALLMENTS = 'SET_INSTALLMENTS'
export const SET_ACTIVE_SERVICES = 'SET_ACTIVE_SERVICES'
export const GET_NOTIFICATIONS_LIST = 'SET_NOTIFICATIONS_LIST'
export const SET_PROFILE_PICTURE = 'SET_PROFILE_PICTURE'
export const SET_ACCESS_PAGE_LIST = 'SET_ACCESS_PAGE_LIST'
export const SET_PROFILE_DATA = 'SET_PROFILE_DATA'
export const SET_LATEST_PAYMENT_FOR_OTHERS = 'SET_LATEST_PAYMENT_FOR_OTHERS'
export const SET_REFLECT_INFO = 'SET_REFLECT_INFO'  
